<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]=true>

    <div class="checkbox-container">
        <res-custom-checkbox [automationId]="modalAutomationId + '-stamp-document-number-checkbox'"
            [(ngModel)]="stampDocumentNumber" content="Stamp Document Number">
        </res-custom-checkbox>
    </div>
</res-base-modal>